/**
 * /affiliates/groups — publisher-groups page (feat #133).
 *
 * Declares a TanStack Router route and renders `AffiliateGroupsPage`. The
 * root wire-up cycle picks this route up after the prod merge; agents never
 * edit `router.tsx` directly.
 */
import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AffiliateGroupsPage } from "@/features/affiliate-groups/AffiliateGroupsPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/affiliates/groups`.
// ---------------------------------------------------------------------------

export const affiliatesGroupsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliates/groups",
	component: AffiliatesGroupsRoute,
});

export default affiliatesGroupsRoute;

// ---------------------------------------------------------------------------
// Page shell — breadcrumb + feature component.
// ---------------------------------------------------------------------------

export function AffiliatesGroupsRoute() {
	return (
		<div className="mx-auto flex w-full max-w-5xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<AffiliateGroupsPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Affiliates</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Groups</li>
			</ol>
		</nav>
	);
}
